import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as ratingAction from './../../../../actions/ratingAction';
import Ratings from './Ratings';

const mapStateToProps = state => {
    return {
        ratingState: state.ratingReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListRatings: (filters) => dispatch(ratingAction.getListRatings(filters)),
        approveRating: (rating) => dispatch(ratingAction.approveRatingAction(rating)),
        deleteRating: (rating, refreshParams) => dispatch(ratingAction.deleteRatingAction(rating, refreshParams)),
        approveRatingReply: (reply) => dispatch(ratingAction.approveRatingReplyAction(reply)),
        deleteRatingReply: (reply, refreshParams) => dispatch(ratingAction.deleteRatingReplyAction(reply, refreshParams)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Ratings));
